declare var require: any
const version = require('../../package.json').version

export const environment = {
  production: false,
  url: "",
  backendVersion: "v1",
  version: version + "--dev"
}
